import {
  GENERAL_CONCEPTUAL_UNDERSTANDING,
  SIGNIFICANT_ERRORS_IN_WORK,
  WORK_IS_COMPLETE_AND_CORRECT
} from 'pages/Teachers/Insights/constants';

export const shouldDisablePublish = ({ status, overallResponseStatus }) => {
  if (
    status === 'complete' &&
    overallResponseStatus === SIGNIFICANT_ERRORS_IN_WORK
  )
    return false;
  if (
    status === 'revise' &&
    [WORK_IS_COMPLETE_AND_CORRECT, GENERAL_CONCEPTUAL_UNDERSTANDING].includes(
      overallResponseStatus
    )
  )
    return false;
  if (status === 'complete' || status === 'revise') return true;

  return false;
};
